import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { CardImage } from '../../utils/cardImageUtils';
import { getTeamAbbr } from '../../utils/teamAbbr';

/**
 * CardImage con lightbox: cliccando sulla miniatura si apre la card come in MyCards.
 * Usa la stessa struttura e CSS di CardItem (profile).
 */
const CardImageLightbox = ({ card, alt, thumbnailClassName, ...rest }) => {
  const [showLightbox, setShowLightbox] = useState(false);
  const normalizedCardKind = String(card?.cardKind ?? card?.card_kind ?? '').toLowerCase();
  const isLegendOrDivinity = normalizedCardKind === 'legend' || normalizedCardKind === 'divinity';
  const playerName = card?.player?.full_name ?? card?.customName ?? card?.custom_name;
  const showNameBar = !isLegendOrDivinity && playerName;
  const r = card?.rarity;
  const rarityName = (typeof r === 'object' && r?.name) ? r.name : (typeof r === 'string' ? r : 'basic');

  return (
    <>
      <button
        type="button"
        onClick={() => setShowLightbox(true)}
        className="flex-shrink-0 p-0 border-0 bg-transparent cursor-pointer rounded-full focus:outline-none focus:ring-2 focus:ring-[#4169E1] focus:ring-offset-2"
        aria-label={alt || 'Apri immagine a schermo intero'}
      >
        <CardImage
          card={card}
          alt={alt}
          className={thumbnailClassName}
          {...rest}
        />
      </button>

      {showLightbox && createPortal(
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/95 backdrop-blur-sm p-4"
          onClick={() => setShowLightbox(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Immagine card a schermo intero"
        >
          <button
            type="button"
            onClick={() => setShowLightbox(false)}
            className="absolute top-4 right-4 z-[10000] w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
            aria-label="Chiudi"
          >
            <X className="w-6 h-6" />
          </button>
          <div
            className="profile-container marketplace-card-lightbox flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className={`group profile-card-item football-card glass-football card-hover card-rarity-${rarityName} ${isLegendOrDivinity ? 'profile-card-no-image-zoom' : ''} relative overflow-hidden p-0 border-0 rounded-none box-border`}
            >
              <div className={`absolute inset-0 z-0 overflow-hidden flex items-center justify-center card-image-rarity-${rarityName} ${isLegendOrDivinity ? 'profile-card-image-shell-no-zoom' : ''}`}>
                <div
                  className={`flex-shrink-0 ${isLegendOrDivinity ? 'profile-card-image-frame-no-zoom' : ''}`}
                  style={isLegendOrDivinity
                    ? undefined
                    : { width: (300 * 300) / 222, height: (450 * 300) / 222, transform: 'translateY(8px)' }}
                >
                  <CardImage
                    card={card}
                    alt={alt}
                    className={`w-full h-full ${isLegendOrDivinity ? 'object-contain' : 'object-cover'}`}
                  />
                </div>
              </div>

              {showNameBar && (
                <div
                  className="profile-card-name-bar absolute bottom-0 left-0 right-0 z-20 text-center text-white px-2 pointer-events-none font-bold"
                  style={{ color: '#fff', WebkitTextStroke: '1.5px black', paintOrder: 'stroke fill', paddingBottom: '2.375rem' }}
                >
                  <div
                    className="profile-card-player-name text-lg"
                    style={rarityName === 'rare' ? { transform: 'translateY(10px)' } : undefined}
                  >
                    {playerName}
                  </div>
                  {card?.player?.team && (
                    <div
                      className="profile-card-team-abbr text-xs absolute text-center"
                      style={{
                        bottom: 0,
                        left: '30%',
                        width: '40%',
                        color: '#fff',
                        WebkitTextStroke: '2px black',
                        paintOrder: 'stroke',
                        background: 'rgb(255 255 255 / 80%)',
                        border: 'none',
                        boxShadow: '1.1px 1.1px 1.1px 1.1px rgb(0, 0, 0)'
                      }}
                    >
                      {getTeamAbbr(card.player.team)}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default CardImageLightbox;
